/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Dialogue_List_DescInputs */

const en_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker-identified DOCX/CSV`)
};

const fr_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX/CSV avec identification des intervenants`)
};

const de_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecheridentifiziertes DOCX/CSV`)
};

const it_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX/CSV identificato dall'oratore`)
};

const ru_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX/CSV, идентифицированный говорящим`)
};

const es_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX/CSV identificado por el hablante`)
};

const zh_cn2_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已识别说话人的 DOCX/CSV`)
};

const ja_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`話者識別DOCX/CSV`)
};

const hi_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता द्वारा पहचाने गए DOCX/CSV`)
};

const pt_pt2_file_export_dialogue_list_desc = /** @type {(inputs: File_Export_Dialogue_List_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DOCX/CSV com identificação do orador`)
};

/**
* | output |
* | --- |
* | "Speaker-identified DOCX/CSV" |
*
* @param {File_Export_Dialogue_List_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_dialogue_list_desc = /** @type {((inputs?: File_Export_Dialogue_List_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Dialogue_List_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_dialogue_list_desc(inputs)
	if (locale === "de") return de_file_export_dialogue_list_desc(inputs)
	if (locale === "it") return it_file_export_dialogue_list_desc(inputs)
	if (locale === "ru") return ru_file_export_dialogue_list_desc(inputs)
	if (locale === "es") return es_file_export_dialogue_list_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_dialogue_list_desc(inputs)
	if (locale === "ja") return ja_file_export_dialogue_list_desc(inputs)
	if (locale === "hi") return hi_file_export_dialogue_list_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_dialogue_list_desc(inputs)
	return en_file_export_dialogue_list_desc(inputs)
});